export default __webpack_public_path__ + "static/media/my-path-logo.290524ffa6a2f27907d47701f08d2d46.svg";